module.exports = __webpack_public_path__ + "img/watatsuki no toyohime_lw.13e635c3.png";